import {SelectElementV2} from "../../../../../../components/common/select/selectElementV2";

export class ConsultationLayout {
    tabs: ConsultationLayoutTab[] = [];

    static fromJSONString(jsonString: string): ConsultationLayout {
        if (!jsonString) return null;

        const plainObject = JSON.parse(jsonString);

        const layout = new ConsultationLayout();
        Object.assign(layout, plainObject);
        layout.tabs = (plainObject.tabs || []).map((tab: any) => {
            const tabInstance = new ConsultationLayoutTab();
            Object.assign(tabInstance, tab);
            return tabInstance;
        });
        // console.log('fromJSONString', layout);
        return layout;
    }

    getTabByTabName(tabName: string): ConsultationLayoutTab {
        return this.tabs.find(value => value.name === tabName);
    }

    getTabOptionByTabName(tabName: string): any {
        const tab = this.getTabByTabName(tabName);
        return tab ? tab.options : undefined;
    }

    getTabOptionByTabNameAndName(tabName: string, optionName: string): any {
        const options: any = this.getTabOptionByTabName(tabName);
        return options ? options[optionName] : null;
    }
}

export class ConsultationLayoutTab {

    public static readonly ANAMNESIS_NAME = 'anamnesis';
    public static readonly ANAMNESIS_TYPE_SIMPLE = 'simple';
    public static readonly ANAMNESIS_TYPE_FORMS = 'forms';
    public static readonly ANAMNESIS_TYPE_SMART = 'smart';
    public static readonly ANAMNESIS_TYPE_ELEMENTS: SelectElementV2<string>[] = [
        new SelectElementV2(ConsultationLayoutTab.ANAMNESIS_TYPE_SMART, 'Intelligente', ConsultationLayoutTab.ANAMNESIS_TYPE_SMART),
        new SelectElementV2(ConsultationLayoutTab.ANAMNESIS_TYPE_SIMPLE, 'Simplifiée', ConsultationLayoutTab.ANAMNESIS_TYPE_SIMPLE),
        new SelectElementV2(ConsultationLayoutTab.ANAMNESIS_TYPE_FORMS, 'Formulaires', ConsultationLayoutTab.ANAMNESIS_TYPE_FORMS)
    ];
    public static readonly ANAMNESIS_SIMPLE_DEFAULT_TEXT = 'defaultText';

    public static readonly OBSERVATIONS_NAME = 'observations';
    public static readonly OBSERVATIONS_TYPE_SIMPLE = 'simple';
    public static readonly OBSERVATIONS_TYPE_SMART = 'smart';
    public static readonly OBSERVATIONS_TYPE_FULL = 'full';
    public static readonly OBSERVATIONS_TYPE_ELEMENTS: SelectElementV2<string>[] = [
        new SelectElementV2(ConsultationLayoutTab.OBSERVATIONS_TYPE_FULL, 'Complet (intelligent + historique)', ConsultationLayoutTab.OBSERVATIONS_TYPE_FULL),
        new SelectElementV2(ConsultationLayoutTab.OBSERVATIONS_TYPE_SMART, 'Intelligent', ConsultationLayoutTab.OBSERVATIONS_TYPE_SMART),
        new SelectElementV2(ConsultationLayoutTab.OBSERVATIONS_TYPE_SIMPLE, 'Simplifié', ConsultationLayoutTab.OBSERVATIONS_TYPE_SIMPLE),
    ];

    public static readonly DIAGNOSTICS_NAME = 'diagnostics';
    public static readonly DIAGNOSTICS_TYPE_SIMPLE = 'simple';
    public static readonly DIAGNOSTICS_TYPE_FULL = 'full';
    public static readonly DIAGNOSTICS_TYPE_ELEMENTS: SelectElementV2<string>[] = [
        new SelectElementV2(ConsultationLayoutTab.DIAGNOSTICS_TYPE_FULL, 'Complet', ConsultationLayoutTab.DIAGNOSTICS_TYPE_FULL),
        new SelectElementV2(ConsultationLayoutTab.DIAGNOSTICS_TYPE_SIMPLE, 'Simplifié', ConsultationLayoutTab.DIAGNOSTICS_TYPE_SIMPLE),
    ];

    public static readonly TREATMENTS_NAME = 'treatments';
    public static readonly TREATMENTS_TYPE_SIMPLE = 'simple';
    public static readonly TREATMENTS_TYPE_FULL = 'full';
    public static readonly TREATMENTS_TYPE_ELEMENTS: SelectElementV2<string>[] = [
        new SelectElementV2(ConsultationLayoutTab.TREATMENTS_TYPE_FULL, 'Complet', ConsultationLayoutTab.TREATMENTS_TYPE_FULL),
        new SelectElementV2(ConsultationLayoutTab.TREATMENTS_TYPE_SIMPLE, 'Simplifié', ConsultationLayoutTab.TREATMENTS_TYPE_SIMPLE),
    ];

    public static readonly PRESCRIPTIONS_NAME = 'prescriptions';
    public static readonly PRESCRIPTIONS_TYPE_SIMPLE = 'with-history';
    public static readonly PRESCRIPTIONS_TYPE_FULL = 'without-history';
    public static readonly PRESCRIPTIONS_TYPE_ELEMENTS: SelectElementV2<string>[] = [
        new SelectElementV2(ConsultationLayoutTab.PRESCRIPTIONS_TYPE_FULL, 'Avec historique', ConsultationLayoutTab.PRESCRIPTIONS_TYPE_FULL),
        new SelectElementV2(ConsultationLayoutTab.PRESCRIPTIONS_TYPE_SIMPLE, 'Sans historique', ConsultationLayoutTab.PRESCRIPTIONS_TYPE_SIMPLE),
    ];

    public static readonly REPORTS_NAME = 'reports';
    public static readonly REPORTS_TYPE_SIMPLE = 'with-history';
    public static readonly REPORTS_TYPE_FULL = 'without-history';
    public static readonly REPORTS_TYPE_ELEMENTS: SelectElementV2<string>[] = [
        new SelectElementV2(ConsultationLayoutTab.REPORTS_TYPE_FULL, 'Avec historique', ConsultationLayoutTab.REPORTS_TYPE_FULL),
        new SelectElementV2(ConsultationLayoutTab.REPORTS_TYPE_SIMPLE, 'Sans historique', ConsultationLayoutTab.REPORTS_TYPE_SIMPLE),
    ];

    public static readonly DOCUMENTS_NAME = 'documents';

    public static readonly BILLING_NAME = 'billing';
    public static readonly BILLING_TYPE_CHARGED_ACT = 'charged-acts';
    public static readonly BILLING_TYPE_WITH_QUOTATIONS = 'charged-acts-and-quotations';
    public static readonly BILLING_TYPE_WITH_QUOTATIONS_AND_HISTORY = 'charged-acts-and-quotations-and-history';

    public static readonly BILLING_TYPE_ELEMENTS: SelectElementV2<string>[] = [
        new SelectElementV2(ConsultationLayoutTab.BILLING_TYPE_WITH_QUOTATIONS_AND_HISTORY, 'Facturation de la consultation + devis + historique', ConsultationLayoutTab.BILLING_TYPE_WITH_QUOTATIONS_AND_HISTORY),
        new SelectElementV2(ConsultationLayoutTab.BILLING_TYPE_WITH_QUOTATIONS, 'Facturation de la consultation + devis', ConsultationLayoutTab.BILLING_TYPE_WITH_QUOTATIONS),
        new SelectElementV2(ConsultationLayoutTab.BILLING_TYPE_CHARGED_ACT, 'Facturation de la consultation', ConsultationLayoutTab.BILLING_TYPE_CHARGED_ACT),
    ];

    public static readonly CONCLUSION_NAME = 'conclusion';
    public static readonly CONCLUSION_DEFAULT_TEXT = 'defaultText';


    public static readonly NEXT_EVENTS_NAME = 'next-events';
    public static readonly ACTIONS_NAME = 'actions';

    public static readonly INSOLES_NAME = 'insoles';

    public static readonly INSTRUMENT_SETS_NAME = 'instrumentSet';

    public static readonly NOTES_NAME = 'notes';

    icon: string;
    name: string;
    label: string;
    options: any;

    public static anamnesis(): ConsultationLayoutTab {
        return {
            icon: 'user-circle',
            name: ConsultationLayoutTab.ANAMNESIS_NAME,
            label: 'Anamnèse',
            options: {
                type: ConsultationLayoutTab.ANAMNESIS_TYPE_SMART
            }
        }
    }

    public static observations(): ConsultationLayoutTab {
        return {
            icon: 'list-details',
            name: ConsultationLayoutTab.OBSERVATIONS_NAME,
            label: 'Observations',
            options: {
                type: ConsultationLayoutTab.OBSERVATIONS_TYPE_FULL
            }
        }
    }

    public static diagnostics(): ConsultationLayoutTab {
        return {
            icon: 'stethoscope',
            name: ConsultationLayoutTab.DIAGNOSTICS_NAME,
            label: 'Diagnostics',
            options: {
                type: ConsultationLayoutTab.DIAGNOSTICS_TYPE_FULL
            }
        }
    }

    public static treatments(): ConsultationLayoutTab {
        return {
            icon: 'vaccine-bottle',
            name: ConsultationLayoutTab.TREATMENTS_NAME,
            label: 'Traitements',
            options: {
                type: ConsultationLayoutTab.TREATMENTS_TYPE_FULL
            }
        }
    }

    public static prescriptions(): ConsultationLayoutTab {
        return {
            icon: 'clipboard-list',
            name: ConsultationLayoutTab.PRESCRIPTIONS_NAME,
            label: 'Prescriptions',
            options: {
                type: ConsultationLayoutTab.PRESCRIPTIONS_TYPE_FULL
            }
        }
    }

    public static reports(): ConsultationLayoutTab {
        return {
            icon: 'file-text',
            name: ConsultationLayoutTab.REPORTS_NAME,
            label: 'Rapports',
            options: {
                type: ConsultationLayoutTab.REPORTS_TYPE_FULL
            }
        }
    }

    public static documents(): ConsultationLayoutTab {
        return {
            icon: 'file',
            name: ConsultationLayoutTab.DOCUMENTS_NAME,
            label: 'Document',
            options: {}
        }
    }

    public static billing(): ConsultationLayoutTab {
        return {
            icon: 'file-dollar',
            name: ConsultationLayoutTab.BILLING_NAME,
            label: 'Facturation',
            options: {
                type: ConsultationLayoutTab.BILLING_TYPE_WITH_QUOTATIONS_AND_HISTORY
            }
        }
    }

    public static conclusion(): ConsultationLayoutTab {
        return {
            icon: 'notes',
            name: ConsultationLayoutTab.CONCLUSION_NAME,
            label: 'Conclusion',
            options: {}
        }
    }

    public static nextEvents(): ConsultationLayoutTab {
        return {
            icon: 'calendar',
            name: ConsultationLayoutTab.NEXT_EVENTS_NAME,
            label: 'Prochains rendez-vous',
            options: {}
        }
    }

    public static actions(): ConsultationLayoutTab {
        return {
            icon: 'bell-plus',
            name: ConsultationLayoutTab.ACTIONS_NAME,
            label: 'Actions',
            options: {}
        }
    }
    public static insoles(): ConsultationLayoutTab {
        return {
            icon: 'shoe',
            name: ConsultationLayoutTab.INSOLES_NAME,
            label: 'Semelles',
            options: {}
        }
    }
    public static instrumentSets(): ConsultationLayoutTab {
        return {
            icon: 'chisel',
            name: ConsultationLayoutTab.INSTRUMENT_SETS_NAME,
            label: 'Sets d\'instrument',
            options: {}
        }
    }
    public static notes(): ConsultationLayoutTab {
        return {
            icon: 'notes',
            name: ConsultationLayoutTab.NOTES_NAME,
            label: 'Notes',
            options: {}
        }
    }
}